import ProductsAPI from '@/services/products-api.service'
import * as productHelpers from '@/helpers/product-sort-filter.js'

export default {
  setCanBeOrdered ({ commit }, canBeOrdered) {
    commit('setCanBeOrdered', canBeOrdered)
  },
  async getAllProducts ({ commit, dispatch }) {
    commit('setLoading', true)
    commit('setLoaded', false)

    await ProductsAPI.getAll()
      .then(products => {
        if (products.data.menu_feed) {
          const reducedProducts = []
          const categories = []
          products.data.menu_feed.menu_groups.map(cat => {
            cat.menu_items.forEach(product => {
              product.category = cat.name.replace(' ', '-')
              product.combine_weights = cat.combine_weights
              reducedProducts.push(product)
            })

            categories.push({
              name: cat.name,
              slug: cat.name.replace(' ', '-'),
              description: cat.description,
              image: cat.image
            })
          })

          commit('setAllProducts', reducedProducts)
          commit('setCategories', categories)
          const prices = reducedProducts.reduce(
            productHelpers.reducePriceRange,
            [Infinity, 0]
          )
          commit('setFilters', {
            priceRange: [
              Math.floor(prices[0] / 100),
              Math.ceil(prices[1] / 100)
            ]
          })
          commit('setPriceRange', [
            Math.floor(prices[0] / 100),
            Math.ceil(prices[1] / 100)
          ])
          dispatch('loadSuccess')
        } else {
          dispatch('loadFail', products)
        }
      })
      .catch(result => {
        dispatch('loadFail', result)
      })
  },

  setCategory ({ commit }, category) {
    commit('setCategory', category)
  },

  toggleView ({ commit }) {
    commit('toggleView')
  },

  loadSuccess ({ commit }) {
    commit('setError', false)
    commit('setLoading', false)
    commit('setLoaded', true)
  },

  loadFail ({ commit }, error) {
    commit('setError', error)
    commit('setLoading', false)
    commit('setLoaded', false)
  },

  filter ({ commit }, filters) {
    commit('setFilters', filters)
  },

  removeFilter ({ commit }, filter) {
    if (filter.key === 'priceRange') {
      commit('resetPriceRangeFilter')
    } else {
      commit('removeFilterValue', filter)
    }
  },

  resetFilters ({ commit }) {
    commit('resetFilters')
  },

  search ({ commit }, term) {
    commit('setSearch', term)
  },

  setSort ({ commit }, sort) {
    commit('setSortField', sort.field)
    commit('setSortDirection', sort.dir)
  }
}
